import { render, staticRenderFns } from "./ButtonModule.vue?vue&type=template&id=5391b3a8&scoped=true&"
import script from "./ButtonModule.vue?vue&type=script&lang=js&"
export * from "./ButtonModule.vue?vue&type=script&lang=js&"
import style0 from "./ButtonModule.vue?vue&type=style&index=0&id=5391b3a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5391b3a8",
  null
  
)

export default component.exports